import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=e6d68a3c"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=e6d68a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports